const loadResource =
  process.env.VUE_APP_API_ENDPOINT +
  "/enterprises/manning/vessels/crews/scheduler/vessel";
const syncResource =
  process.env.VUE_APP_API_ENDPOINT +
  "/enterprises/manning/vessels/crews/scheduler/vessel/events";

const headers = {
  tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
  locale: window.navigator.language,
};

export default {
  load: {
    url: loadResource,
    headers: headers,
  },
  sync: {
    url: syncResource,
    headers: headers,
  },
};
